export default __webpack_public_path__ + "static/media/coinlogo.83dcab57.png";